import getRuntimeConfiguration from 'utils/getRuntimeConfiguration';
import { isNode } from '../utils/environment';

const defaultWordpressServiceConfig = {
  root: getRuntimeConfiguration('WORDPRESS_API_ROOT'),
  pluginRoot: getRuntimeConfiguration('WORDPRESS_API_PLUGIN_ROOT'),
  options: getRuntimeConfiguration('WORDPRESS_API_OPTIONS'),
};

const wordpressConfig = isNode() ? {
  ...defaultWordpressServiceConfig,
  // Viewing drafts or revisions requires authentication.
  username: getRuntimeConfiguration('WORDPRESS_API_USERNAME'),
  password: getRuntimeConfiguration('WORDPRESS_API_PASSWORD'),
} : defaultWordpressServiceConfig;

export default async function locateRemoteService() {
  const serviceName = getRuntimeConfiguration('WORDPRESS_SERVICE_NAME') || 'babbelWordPressRestApi';
  const module = await import(`./${serviceName}/index`);
  const Service = module.default;
  switch (serviceName) {
    case 'wordPressRestApi':
    case 'babbelWordPressRestApi':
    default:
      return new Service(wordpressConfig);
  }
}
